import React from "react";

import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

import JSONEditor from "../../../../components/JSONEditor/JSONEditor";


const useStyles = makeStyles(() => ({
  editor: {
    margin: 0,
    marginTop: 20,
  },
  title: {
    marginBottom: "4px",
  },
}));

type ValuesMappingEditorProps = {
  mapping: any;
  onMappingChanged: (json: any) => void;
};

const ValuesMappingEditor: React.FC<ValuesMappingEditorProps> = ({
  mapping,
  onMappingChanged = () => {},
}) => {
  const classes = useStyles();

  const jsonChanged = (json: string) => {
    try {
      JSON.parse(json);
    } catch (e) {
      return;
    }
    const { name = "", values = [] } = JSON.parse(json);

    onMappingChanged({
      name,
      values,
    });
  };

  return (
    <JSONEditor
      value={mapping}
      width="100%"
      jsonChanged={jsonChanged}
      className={classes.editor}
      customTitle={
        <Typography variant="subtitle1" className={classes.title}>
          Mapping JSON
        </Typography>
      }
    />
  );
};

export default ValuesMappingEditor;
